import React from 'react'
// import { Logo } from '../components/Images'

function Sidebar() {
    return (
        <div>
            <div>
                <ul className="sidebar--items">
                    <li className="sidebar__item" style={{textAlign:'center'}}><b>Menu</b><hr/></li>
                </ul>
            </div>
        </div>
    )
}

export default Sidebar
